export default __webpack_public_path__ + "static/media/02.616b3f68.jpg";